const getLabelParts = (label: string) => label.trim().split(' ');

export const getLabelInitials = (label: string) => getLabelParts(label)[0]?.[0]?.toUpperCase() || '';
